import { supabase } from "../../supabase/supabase";
import type { LanguageCode } from "@/config/language-rules";

export interface RewriteGreetingInput {
  text: string;
  language: LanguageCode;
}

/**
 * Rewrites a first message in the given language through the rewrite_greeting edge function.
 * Throws an Error with a short message when the call fails or the answer is rejected.
 */
export async function rewriteGreeting({
  text,
  language,
}: RewriteGreetingInput): Promise<string> {
  const { data, error } = await supabase.functions.invoke("rewrite_greeting", {
    body: { text, language },
  });

  if (error) {
    // A non-2xx answer carries the function's own { error } message in the response body.
    let message: string | undefined;
    try {
      const body = await (error as any).context?.json?.();
      message = body?.error;
    } catch {
      // keep the generic message
    }
    throw new Error(message || error.message || "Could not rewrite the greeting");
  }

  if (!data || typeof data.text !== "string" || data.text.trim() === "") {
    throw new Error("The rewrite came back empty");
  }
  return data.text;
}
